import { type PropsWithChildren, useCallback, useEffect } from 'react';
import {
    getKameleoonFeaturesFromStorage,
    storeKameleoonFeatures,
    useKameleoonState,
} from '@lingoda/kameleoon';
import { actualizeMatomoData } from '@lingoda/analytics';

export const MatomoBlock = ({ children }: PropsWithChildren<unknown>) => {
    const { state } = useKameleoonState();

    const updateMatomo = useCallback(() => {
        if (state.status !== 'initialized') {
            return;
        }

        const { features, visitorCode } = state;
        if (!Object.keys(features).length) {
            return;
        }

        const initialFeatures = getKameleoonFeaturesFromStorage();

        const newFeatures: Record<string, string> = {
            ...initialFeatures,
            ...features,
        };

        if (JSON.stringify(initialFeatures) !== JSON.stringify(newFeatures)) {
            storeKameleoonFeatures(newFeatures);
            actualizeMatomoData(visitorCode, newFeatures);
        }
    }, [state]);

    useEffect(() => {
        updateMatomo();
    }, [updateMatomo]);

    return <>{children}</>;
};
